import React, { PropsWithChildren } from 'react'
import styled from 'styled-components'

const Container = styled.div`
  margin-bottom: 26px;
`

const Caption = styled.div`
  font-size: smaller;
  margin-top: 12px;
`

const Img = styled.img`
  max-width: 100%;
`

interface IProps {
  src: string
  credits?: string
}

const ImageControl = (props: PropsWithChildren<IProps>) => {
  const parts = props.src.split('/')
  const altText = parts[parts.length - 1]
    .split('.')[0]
    .replace(/_/g, ' ')
    .replace(/-/g, ' ')

  return (
    <Container>
      <Img src={props.src} alt={altText} />
      {props.children && <Caption>{props.children}</Caption>}
      {props.credits && <Caption>{props.credits}</Caption>}
    </Container>
  )
}

export default ImageControl
